import type { PortfolioData } from '../domain/portfolio.types';
import { SocialIcon } from '../../../shared/ui/SocialIcon';
import profileImage from '../../../assets/protifilio_profile.png';
import { Link } from 'react-router-dom';


function Ticker({ data }: { data: PortfolioData }) {
  const items = [
    "VIBE CODING",
    "SHIPPING SCALABLE SAAS IN WEEKS",
    "AVAILABLE FOR HIRE",
    ".NET · ANGULAR · FLUTTER · REACT",
    `BASED · ${data.identity.location.toUpperCase()}`,
  ];
  const all = [...items, ...items];
  return (
    <div className="ticker">
      <div className="ticker-track">
        {all.map((t, i) => (
          <span key={i}>{t}<span className="pip"> ◆ </span></span>
        ))}
      </div>
    </div>
  );
}

export function Hero({ data }: { data: PortfolioData }) {
  const { identity, stats, contact } = data;

  return (
    <section className="hero" id="top">
      <div className="container">
        <div className="hero-grid">
          <div className="hero-left">
            <div className="hero-eyebrow reveal">
              <span className="live"></span>
              {identity.available ? 'AVAILABLE FOR FULL-TIME ' : 'NOT AVAILABLE FOR FULL-TIME'}
              <span style={{ color: 'var(--fg-mute)' }}>·</span>
              {identity.location}
            </div>
            <h1 className="hero-name reveal">
              <span className="hero-role-label">{identity.heroSub || identity.role}</span>
              <span className="l1">
                <span className="glitch-word" data-text={identity.heroL1}>{identity.heroL1}</span>
              </span>
              <span className="l2">{identity.heroL2}</span>
            </h1>
            <p className="hero-tagline reveal">
              <span className="hl">{identity.role}.</span> {identity.tagline}
            </p>
            <div className="hero-summary reveal">
              <span className="lead">// summary &nbsp;</span>
              {identity.summary}
            </div>
            <div className="hero-cta reveal">
              <Link className="btn btn-primary" to="/projects">View work <span className="arrow">→</span></Link>
              <a className="btn" href="#contact">Get in touch</a>
              <a className="btn" href={data.contact.resume || '#'} target="_blank" rel="noopener noreferrer">Resume.pdf ↓</a>
            </div>
            <div className="hero-quick reveal" aria-label="Quick links">
              <a className="quick-link" href={`mailto:${contact.email}`} title={contact.email}>
                <SocialIcon kind="email" />
                <span className="ql-label">Email</span>
                <span className="ql-val">{contact.email}</span>
              </a>
              {contact.socials.slice(0, 2).map((s, i) => (
                <a key={i} className="quick-link" href={s.url} target="_blank" rel="noopener noreferrer" title={s.k}>
                  <SocialIcon kind={s.k === 'LN' ? 'linkedin' : s.k === 'GH' ? 'github' : s.k} />
                  <span className="ql-label">{s.k === 'LN' ? 'LinkedIn' : s.k === 'GH' ? 'GitHub' : s.k}</span>
                  <span className="ql-val">{s.v}</span>
                </a>
              ))}
            </div>
          </div>

          <div className="hero-stats reveal">
            {stats.map((s, i) => (
              <div className="hero-stat" key={i}>
                <div className="v">{s.v}<span className="unit">{s.unit}</span></div>
                <div className="l">{s.l}</div>
              </div>
            ))}
          </div>

          <div className="hero-right reveal" style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', alignSelf: 'flex-start', position: 'relative', filter: 'drop-shadow(0 0 28px rgba(232, 82, 60, 0.3))' }}>
            <img
              src={profileImage}
              alt="Akash Jaiswal"
              style={{
                width: '100%',
                maxWidth: '500px',
                height: 'auto',
                display: 'block'
              }}
            />
          </div>
        </div>
      </div>
      <Ticker data={data} />
    </section>
  );
}
